<template>
  <div class="destination-cards" :class="orientation">
    <destination-option-card
      icon="mdi-passport"
      :orientation="orientation"
      :title="$t('digital_product_passport')"
      :description="$t('destination_dpp_desc')"
      :selected="value === 'dpp'"
      @select="$emit('input', 'dpp')"
    >
      <template v-if="$slots['dpp-action']" v-slot:action>
        <slot name="dpp-action"></slot>
      </template>
    </destination-option-card>

    <destination-option-card
      icon="mdi-cellphone"
      :orientation="orientation"
      :title="$t('custom_landing_page')"
      :description="$t('destination_custom_desc')"
      :selected="value === 'custom'"
      @select="$emit('input', 'custom')"
    >
      <template v-if="$slots['custom-action']" v-slot:action>
        <slot name="custom-action"></slot>
      </template>
    </destination-option-card>

    <destination-option-card
      icon="mdi-history"
      :orientation="orientation"
      :title="$t('use_existing_landing_page')"
      :description="$t('destination_existing_desc')"
      :selected="value === 'existing'"
      @select="$emit('input', 'existing')"
    />

    <destination-option-card
      icon="mdi-link"
      :orientation="orientation"
      :title="$t('redirect_to_custom_url')"
      :description="$t('destination_redirect_desc')"
      :selected="value === 'redirect'"
      @select="$emit('input', 'redirect')"
    />
  </div>
</template>

<script>
import DestinationOptionCard from '@/components/redirection/DestinationOptionCard.vue'

export default {
  name: 'DestinationCards',
  components: { DestinationOptionCard },
  props: {
    // 'dpp' | 'custom' | 'existing' | 'redirect'
    value: { type: String, required: true },
    orientation: { type: String, default: 'horizontal' }
  }
}
</script>

<style lang="sass" scoped>

.destination-cards
  display: flex
  gap: 16px

.destination-cards.horizontal
  max-width: 1156px

.destination-cards > *
  flex: 1

</style>
